import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { SITEDETAIL } from "@/constants/testIds";
import { Stat } from "./_ui";
import StaticOverview from "./panels/StaticOverview";

export default function OverviewTab({ site, reload }) {
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState(null);
  if (site.site_type === "static") return <StaticOverview site={site} />;

  async function ingest() {
    setBusy(true);
    try {
      const r = await api.post("/sources/ingest", { site_id: site.id, max_items_per_source: 8 });
      setOut(r.data);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <Stat label="Articles total" value={site.articles_count || 0} />
      <Stat
        label="AI spend today"
        value={"$" + (site.ai_spend_today_usd || 0).toFixed(3)}
        sub={`Cap $${(site.ai_budget_daily_usd || 0).toFixed(2)}/day`}
      />
      <Stat label="Status" value={site.status} />
      <div className="lg:col-span-3 border border-zinc-800 rounded-sm p-5 bg-zinc-900/40">
        <div className="flex items-center justify-between mb-3">
          <div className="label-tiny">Content Pipeline</div>
          <button
            data-testid={SITEDETAIL.ingestButton}
            disabled={busy}
            onClick={ingest}
            className="inline-flex items-center gap-2 bg-white text-zinc-950 hover:bg-zinc-200 disabled:opacity-50 px-3 py-1.5 rounded-sm text-xs font-semibold"
          >
            {busy ? <Loader2 className="animate-spin" size={12} /> : <RefreshCw size={12} />}
            Ingest Now
          </button>
        </div>
        <div className="text-xs text-zinc-400">
          Pulls from {site.template === "terminal" ? "finance feeds" : "all configured RSS sources"} and queues new articles for AI rewrite.
        </div>
        {out && (
          <div className="mt-4 font-mono text-xs text-zinc-300 border-t border-zinc-800 pt-3 space-y-1">
            <div>fetched={out.total_fetched}  new={out.total_new}  deduped={out.total_deduped}</div>
            {out.per_source?.map((p) => (
              <div key={p.source || p.url} className="text-zinc-500">
                · {p.source}: {p.fetched ?? 0} fetched, {p.new ?? 0} new, {p.deduped ?? 0} dedup
                {p.error && <span className="text-red-400"> (err: {p.error})</span>}
              </div>
            ))}
            <div className="pt-2">
              <Link to="/admin/moderation" className="text-amber-500 underline">Review &amp; publish in moderation queue →</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
